/* eslint-disable no-console */
<template>
    <ion-page>
        <div
            style="display:flex; align-items:center; justify-content:center; height: 100%; flex-direction: column;"
        >

            <div style="margin-top: 1rem; width: 100%; text-align:center;" v-if="downloadingUpdate">
                Downloading update...
                 <ion-progress-bar
                    :value="updateProgress"
                    style="margin-top: 1rem;"
                ></ion-progress-bar>
            </div>

            <div style="margin-top: 1rem; width: 100%; text-align:center;" v-if="extractingUpdate">
                    Installing update...
                 <ion-progress-bar
                    :value="extractionProgress"
                    style="margin-top: 1rem;"
                ></ion-progress-bar>
            </div>
           
        </div>
    </ion-page>
</template>

<script>
import { Deploy } from "cordova-plugin-ionic"
export default {
    data() {
        return {
            updateProgress: 0,
            extractionProgress: 0,
            downloadingUpdate: false,
            extractingUpdate: false
        }
    },
    methods: {
        async update() {
           
            const update = await Deploy.checkForUpdate()
             // eslint-disable-next-line no-console

            if (update.available) {
                // eslint-disable-next-line no-console
                this.downloadingUpdate = true
                await Deploy.downloadUpdate((progress) => {
                   this.updateProgress = progress / 100
                })
                this.downloadingUpdate = false
                
                this.extractingUpdate = true

                await Deploy.extractUpdate((progress) => {
                    this.extractionProgress = progress / 100
                })

                await Deploy.reloadApp()

                this.extractingUpdate = false
            }
            this.$router.push('/')
        },
    },
    mounted() {
        this.update()
    },
}
</script>

<style lang="scss" scoped></style>
